
import Vue from 'vue'

const locales = {keys(){return []}}
global['____F97D863____'] = true;
delete global['____F97D863____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"人教点读","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8"}};
global.__uniConfig.compilerVersion = '4.45';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__F97D863';
global.__uniConfig.appName = 'rjdd_uni';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"./"};
global.__uniConfig.publicPath = "./";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-home-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/home/index"+'.vue')), 'pages-home-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-myStudy-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/myStudy/index"+'.vue')), 'pages-myStudy-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-download-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/download/index"+'.vue')), 'pages-download-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-userInfo-myOrder-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/userInfo/myOrder/index"+'.vue')), 'pages-userInfo-myOrder-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-userInfo-myPurchased-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/userInfo/myPurchased/index"+'.vue')), 'pages-userInfo-myPurchased-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-userInfo-myShopCart-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/userInfo/myShopCart/index"+'.vue')), 'pages-userInfo-myShopCart-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-loginpage-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/login/loginpage/index"+'.vue')), 'pages-login-loginpage-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-mpwdpage-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/login/mpwdpage/index"+'.vue')), 'pages-login-mpwdpage-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-confirmOrder-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/confirmOrder/index"+'.vue')), 'pages-confirmOrder-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pay-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/pay/index"+'.vue')), 'pages-pay-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-purchase-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/purchase/index"+'.vue')), 'pages-purchase-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-consult-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/consult/index"+'.vue')), 'pages-consult-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/details/index"+'.vue')), 'pages-details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-course-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/course/index"+'.vue')), 'pages-course-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-courseDetails-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/courseDetails/index"+'.vue')), 'pages-courseDetails-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-videoPlay-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/videoPlay/index"+'.vue')), 'pages-videoPlay-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-test-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/人教点读自营版版本管理/web1-2-0/pages/test/index"+'.vue')), 'pages-test-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/home/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"全部教材","titleNView":false})
      },
      [
        createElement('pages-home-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-home-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/myStudy/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的学习","titleNView":false})
      },
      [
        createElement('pages-myStudy-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-myStudy-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/myStudy/index',
  windowTop:0
}
},
{
path: '/pages/download/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-download-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-download-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/download/index',
  windowTop:0
}
},
{
path: '/pages/userInfo/myOrder/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-userInfo-myOrder-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-userInfo-myOrder-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/userInfo/myOrder/index',
  windowTop:0
}
},
{
path: '/pages/userInfo/myPurchased/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-userInfo-myPurchased-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-userInfo-myPurchased-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/userInfo/myPurchased/index',
  windowTop:0
}
},
{
path: '/pages/userInfo/myShopCart/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-userInfo-myShopCart-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-userInfo-myShopCart-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/userInfo/myShopCart/index',
  windowTop:0
}
},
{
path: '/pages/login/loginpage/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录人教点读","titleNView":false})
      },
      [
        createElement('pages-login-loginpage-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-loginpage-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/loginpage/index',
  windowTop:0
}
},
{
path: '/pages/login/mpwdpage/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改密码","titleNView":false})
      },
      [
        createElement('pages-login-mpwdpage-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-mpwdpage-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/mpwdpage/index',
  windowTop:0
}
},
{
path: '/pages/confirmOrder/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-confirmOrder-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-confirmOrder-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/confirmOrder/index',
  windowTop:0
}
},
{
path: '/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
  windowTop:0
}
},
{
path: '/pages/pay/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-pay-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pay-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pay/index',
  windowTop:0
}
},
{
path: '/pages/purchase/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-purchase-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-purchase-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/purchase/index',
  windowTop:0
}
},
{
path: '/pages/consult/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-consult-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-consult-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/consult/index',
  windowTop:0
}
},
{
path: '/pages/details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/details/index',
  windowTop:0
}
},
{
path: '/pages/course/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-course-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-course-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/course/index',
  windowTop:0
}
},
{
path: '/pages/courseDetails/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-courseDetails-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-courseDetails-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/courseDetails/index',
  windowTop:0
}
},
{
path: '/pages/videoPlay/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-videoPlay-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-videoPlay-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/videoPlay/index',
  windowTop:0
}
},
{
path: '/pages/test/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"人教点读","titleNView":false})
      },
      [
        createElement('pages-test-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-test-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/test/index',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
